import React /*, { useEffect, useState, useCallback, useRef }*/ from 'react';

import css from './styles.module.scss';

/**
 * React component: CodeEditorPicker
 * 
 * The picker used to show parts of a code, opening its full
 * content when cliecked
 * 
 * @param {Object} props Component's properties
 * @return {ReactComponent} CodeEditorPicker
 */
export default function CodeEditorPicker (props) {
  const {
    className = '',
    children,
    apis,
    value,
    scope,
    required,
    onChange,
    name,
    options,
    placeholder,
    readOnly,
    ...other
  } = props;

  function openEditor () {
    apis.window.spawn(
      "CodeEditor",
      {
        placeholder,
        readOnly,
        code: value || '',
        lang: options.lang || other.lang,
        onDone: result => {
          const { lang, code } = result;
          const target = {
            scope,
            name,
            value: code,
            lang
          };
          const event = {type: 'change', target};
          onChange && onChange(event, target);
        }
      },
      {
        tied: true,
        windowOptions: {
          // height: 450,
          // width: 680,
        },
      }
    );
  }

  return (
    <div
      className={`${css['CodeEditorPicker-container']} ${className}`}
      {...other}
    >
      <textarea
        readOnly
        rows={2}
        onClick={openEditor}
        value={
          props
            .value
            ?.substring(0, 100)
            ?.replace(/[\t\n(  )]/g, ' ')
        }
      />
      {children}
    </div>
  );
}
